export const httpsScheme = 'https://';

export const facebookBaseUrl = 'facebook.com/';
export const twitterBaseUrl = 'x.com/';
export const tikTokBaseUrl = 'tiktok.com/';
export const youTubeBaseUrl = 'youtube.com/';
export const gitHubBaseUrl = 'github.com/';
export const linkedInBaseUrl = 'linkedin.com/in/';
